// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageContainerStyles } from "@tps/Overrides/Widgets/Cart/CartPageContainer";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

cartPageContainerStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
cartPageContainerStyles.headerContainer = {
    css: css`
        margin-bottom: 0;
    `,
};
cartPageContainerStyles.cartLinesContainer = {
    css: css`
        width: calc(100% - 317px);
        padding-right: 22px;

        ${xScreen("lte", "md")} {
            width: calc(100% - 358px);
        }

        ${xScreen("lte", 767)} {
            width: 100%;
            padding-right: 0;
        }
    `,
};
cartPageContainerStyles.cartTotalContainer = {
    css: css`
        width: 317px;

        ${xScreen("lte", "md")} {
            width: 358px;
        }

        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
cartPageContainerStyles.productCarouselContainer = {
    css: css``,
};
cartPageContainerStyles.linesTotalWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        ${xScreen("lte", 767)} {
            flex-direction: column;
        }
    `,
};
